import { Constants } from "config/constants";
import HelloSign from "hellosign-embedded";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSignUrlAsync, initializeClient } from "state/slices/esignature";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { XCircleIcon } from "@heroicons/react/outline";
import { getIpAddress } from "utils/ipAddress";
import signatureIdService from "services/signatureId";

const EmbeddedClientSigning = () => {
  const dispatch = useDispatch();
  const esignature = useSelector((state) => state.esignatureSlice);

  const client = esignature.client;
  const searchParams = new URLSearchParams(window.location.search);
  const decodedUrl = window.atob(searchParams.get("q"));
  const splitUrl = decodedUrl.split("&");
  const signatureId = splitUrl[0];
  const companyName = splitUrl[1];
  const history = useHistory();
  const { currentUser } = useSelector((state) => state.authSlice);
  const [showTimer, setShowTimer] = useState(false);
  let Icon = XCircleIcon;

  useEffect(() => {
    if (esignature.client === null) {
      const client = new HelloSign();
      dispatch(initializeClient(client));
    }
  }, [esignature.client]);

  useEffect(() => {
    if (esignature.signUrl !== null) {
      /**Open the client */
      client.open(esignature.signUrl, {
        clientId: Constants.HELLO_SIGN.CLIENT_ID,
        skipDomainVerification: true,
        container: document.getElementById("sign-here"),
      });
      /** Handle events after a client signs */
      client.once("sign", async (data) => {
        const ipAddress = await getIpAddress();
        const signatureId = data.signatureId;
        await signatureIdService.create({ ipAddress, signatureId });
        setShowTimer(true);
      });
      /** Handle what happens when client declines to sign */
      client.once("decline", (data) => {
        setShowTimer(true);
      });
    }
  }, [esignature.signUrl]);

  useEffect(async () => {
    if (signatureId !== null) {
      dispatch(createSignUrlAsync({ signatureId }));
      return;
    }
  }, []);

  const Timer = () => {
    const [time, setTime] = useState(10);

    useEffect(() => {
      let timer = setInterval(() => {
        setTime((time) => {
          if (time === 1) {
            clearInterval(timer);
            history.push("/");
            return 0;
          } else return time - 1;
        });
      }, 1000);
    }, []);

    return (
      <div
        style={{
          placeSelf: "center",
        }}
      >
        <h1 className="text-xl text-center">
          {" "}
          Redirecting you to the homepage in {time} secs
        </h1>
      </div>
    );
  };

  if (esignature.signUrl !== null && showTimer === false) {
    return (
      <div
        style={{
          width: "100%",
          height: "95vh",
          margin: "auto",
        }}
      >
        <section
          style={{
            placeContent: "center",
            marginBottom: "30px",
          }}
        >
          <h1 className=" font-semibold text-primary">
            <span className="text-3xl">{companyName}</span>{" "}
            <span className="text-3xl">(In formation)</span>
          </h1>
          <div className="p-4 my-4 rounded-md bg-lime-50 shadow">
            <div className="flex">
              <div className="flex-shrink-0"></div>
              <div className="ml-3">
                <p className="text-sm font-medium text-sflPrimary">
                  Kindly click on "Get Started" button to start the signing
                  ceremony
                </p>
              </div>
            </div>
          </div>
        </section>
        <div
          id="sign-here"
          style={{
            height: "90%",
          }}
        ></div>
      </div>
    );
  }

  if (showTimer === true) {
    if (currentUser?.role) {
      return (
        <div className="flex items-center justify-center h-screen bg-gray-100">
          <div className=" p-6 bg-white rounded shadow-md">
            <h1 className="text-lg mb-4 max-w-3xl">
              "Thank you for signing the document! You will now be redirected to
              the homepage. If you have any questions or need further
              assistance, please don't hesitate to contact us. Have a great
              day!"
            </h1>
            <Timer />
          </div>
        </div>
      );
    } else {
      return (
        <div className="flex items-center justify-center h-screen bg-gray-100">
          <div className=" p-6 bg-white rounded shadow-md">
            <h1 className="text-lg mb-4 max-w-3xl">
              "Thank you for signing the document! To access the full features
              of our platform, please take a moment to register. You will be
              redirected to the landing page where you can create your account
              and continue with your document signing process."
            </h1>
            <Timer />
          </div>
        </div>
      );
    }
  }

  if (esignature.errorMessage !== null || showTimer === true) {
    return (
      <div>
        <div className="p-4 my-4 rounded-md bg-red-100 shadow ">
          <div className="flex">
            <div className="flex-shrink-0">
              <Icon className="w-8 h-8 text-red-600" aria-hidden="true" />
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-sflPrimary">
                {esignature.errorMessage}
              </p>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center h-screen bg-gray-100">
          <div className=" p-6 bg-white rounded shadow-md">
            {esignature.errorMessage === "Signature not found" ? (
              <h1 className="text-lg mb-4 max-w-3xl">
                This signature request has been cancelled. Kindly contact
                support for further assistance. Thank you for your
                understanding.
              </h1>
            ) : (
              <h1 className="text-lg mb-4 max-w-3xl">
                Oops! It looks like we encountered an error while processing
                your request. Please try again or contact support for further
                assistance. Thank you for your understanding.
              </h1>
            )}

            <Timer />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-100">
        <div className=" p-6 bg-white rounded shadow-md">
          <h1 className="text-lg mb-4 max-w-3xl">
            "Please wait a moment while we retrieve the documents for you. Thank
            you for your patience."
          </h1>
          <p className="flex justify-center py-4">
            <SpinnerIcon className="text-gray-500" />
          </p>
        </div>
      </div>
    );
  }
};

export default EmbeddedClientSigning;
